export const Engine_Daily = [
    {
        seq_no:"1",
        question:"Main engine’s coolant level",
    },
    {
        seq_no:"2",
        question:"Main engines oil level",
    },
    {
        seq_no:"3",
        question:"ME's Cooling temperature",
    },
    {
        seq_no:"4",
        question:"ME's oil pressure",
    },
    {
        seq_no:"5",
        question:"ME's no water, Oil, FO leaks",
    },
    {
        seq_no:"6",
        question:"ME Exhaust temperature is normal and no leakage.",
    },
    {
        seq_no:"7",
        question:"ME_ No abnormal noise/vibration",
    },
    {
        seq_no:"8",
        question:"DG's coolant level",
    },
    {
        seq_no:"9",
        question:"DG's Oil level",
    },
    {
        seq_no:"10",
        question:"DG's Coolant temperature",
    },
    {
        seq_no:"11",
        question:"DG's oil pressure",
    },
    {
        seq_no:"12",
        question:"DG's no water, Oil  FO leaks.",
    },
    {
        seq_no:"13",
        question:"DG Exhaust temperature normal and no leakage",
    },
    {
        seq_no:"14",
        question:"DG_ No abnormal noise/vibration.",
    },
    {
        seq_no:"15",
        question:"Propulsion GB's oil pressure /temp are normal",
    },
    {
        seq_no:"16",
        question:"Propulsion GB's no vibration/abnormal noise",
    },
    {
        seq_no:"17",
        question:"Intermediate shaft bearing normal temperature",
    },
    {
        seq_no:"18",
        question:"Stern tubes seal no water leakage.",
    },
    {
        seq_no:"19",
        question:"Bilges are dry and clean.",
    },
    {
        seq_no:"20",
        question:"Generator Voltage/Frequency are normal.",
    },
    {
        seq_no:"21",
        question:"Steering room bilge dry",
    },
    {
        seq_no:"22",
        question:"Rudder stock glands no water leakage",
    },
    {
        seq_no:"23",
        question:"SW pipes /valves no leakage",
    },
]

export const Engine_Weekly = [
    {
        seq_no:"1",
        question:"Main engines oil level?"
    },
    {
        seq_no:"2",
        question:"G Exhaust temperature normal and no leakage.?"
    },
    {
        seq_no:"3",
        question:"DG's Coolant temperature?"
    },
    {
        seq_no:"4",
        question:"DG's Coolant temperature?"
    },
    {
        seq_no:"5",
        question:"Main engines oil level?"
    },
]

export const Engine_Monthly = [
    {
        seq_no:"1",
        question:"Main engines oil level?"
    },
    {
        seq_no:"2",
        question:"G Exhaust temperature normal and no leakage.?"
    },
    {
        seq_no:"3",
        question:"DG's Coolant temperature?"
    },
    {
        seq_no:"4",
        question:"DG's Coolant temperature?"
    },
    {
        seq_no:"5",
        question:"Main engines oil level?"
    },
]

export const Deck_Daily = [
    {
        seq_no:"1",
        question:"AIS",
    },
    {
        seq_no:"2",
        question:"Navtex",
    },
    {
        seq_no:"3",
        question:"Chart plotter",
    },
    {
        seq_no:"4",
        question:"GPS",
    },
    {
        seq_no:"5",
        question:"Gyro Heading Indicator",
    },
    {
        seq_no:"6",
        question:"Magnetic compass",
    },
    {
        seq_no:"7",
        question:"Radar",
    },
    {
        seq_no:"8",
        question:"Echo sounder display(s)",
    },
    {
        seq_no:"9",
        question:"Auto pilot",
    },
    {
        seq_no:"10",
        question:"Anemometer",
    },
    {
        seq_no:"11",
        question:"VHF fixed radio(s)",
    },
    {
        seq_no:"12",
        question:"VHF portable radio(s)",
    },
    {
        seq_no:"13",
        question:"Emergency Walkie talkies",
    },
    {
        seq_no:"14",
        question:"Intercom",
    },
    {
        seq_no:"15",
        question:"Public Address system",
    },
    {
        seq_no:"16",
        question:"Horn",
    },
    {
        seq_no:"17",
        question:"Navigation lights and panel",
    },
    {
        seq_no:"18",
        question:"General Alarm",
    },
    {
        seq_no:"19",
        question:"Search Light",
    },
    {
        seq_no:"20",
        question:"Cabins: clean flooring, beds and mattresses in satisfactory condition, clothes locker are tide and clean, no unnecessary items stored improperly",
    },
    {
        seq_no:"21",
        question:"Galley: walls, ceiling, and floors are clean and grease-free",
    },
    {
        seq_no:"22",
        question:"Toilets: Toilets and Showers are well maintained, cleaned",
    },
]

export const Deck_Weekly = [
    {
        seq_no:"1",
        question:"Mooring rope"
    },
    {
        seq_no:"2",
        question:"Towing rope"
    },
    {
        seq_no:"3",
        question:"Towing hook"
    },
    {
        seq_no:"4",
        question:"Webbing Sling"
    },
    {
        seq_no:"5",
        question:"Chain block"
    },
    {
        seq_no:"6",
        question:"Bow shackle"
    },
    {
        seq_no:"7",
        question:"Crane"
    },
    {
        seq_no:"8",
        question:"All crew have adequate PPE"
    },
    {
        seq_no:"9",
        question:"Sanitary: Toilet facilities are clean, operational and hygienic. Hot and Cold water are available"
    },
    {
        seq_no:"10",
        question:"Air Condition filters clean "
    },
    {
        seq_no:"11",
        question:"Galley: Check the condition of Galley fans ensure exhaust fan operationa"
    },
    {
        seq_no:"12",
        question:"Galley exhausts to be cleaned"
    },
    {
        seq_no:"13",
        question:"Freezers are working with correct temperature"
    },
    {
        seq_no:"14",
        question:"workspaces: Bridge is well organized with no unnecessary items stored, library and file cabinets are neatly shelved."
    },
    {
        seq_no:"15",
        question:"Anchor and winches"
    },
    {
        seq_no:"16",
        question:"Engine telegraph "
    },
    {
        seq_no:"17",
        question:"Hatches rubber gasket and butterfly nuts"
    },
]

export const Deck_Monthly = [
    {
        seq_no:"1",
        question:"Life raft (External condition, Painter line condition,  Proper stowage, Name & port of reg.)"
    },
    {
        seq_no:"2",
        question:"Life raft HRU (Certificate, Disposal date, correct connection)"
    },
    {
        seq_no:"3",
        question:"Lifebuoys (Condition, Reflective tape, Name & port of reg., grab line, Self-igniting lights)"
    },
    {
        seq_no:"4",
        question:"Lifejackets (Condition, Name & port of reg., Light &  Expiry date, whistle)"
    },
    {
        seq_no:"5",
        question:"Work vests (Condition, fasteners)"
    },
    {
        seq_no:"6",
        question:"Pyrotechnics: Rocket parachutes, Hand flares orange smoke signal, MOB and LTA"
    },
    {
        seq_no:"7",
        question:"SART (Condition, Battery expiry date, Annual  Certificate)"
    },
    {
        seq_no:"8",
        question:"EPIRB (Condition, Battery expiry date, Annual Certificate, HRU"
    },
    {
        seq_no:"9",
        question:"Fireman’s outfit and inventory"
    },
    {
        seq_no:"10",
        question:"BA sets and bottles."
    },
    {
        seq_no:"11",
        question:"Fire hydrants, hoses and nozzles"
    },
    {
        seq_no:"12",
        question:"Fireboxes"
    },
    {
        seq_no:"13",
        question:"Fire extinguishers (DCP, Co2, Foam)"
    },
    {
        seq_no:"14",
        question:"Check Fire Control Plan with the crew list"
    },
    {
        seq_no:"15",
        question:"Check damage control box, adequate equipment, MSDS and inventory posted and updated"
    },
    {
        seq_no:"16",
        question:"Check SOPEP kit, adequate equipment, MSDS and inventory posted and updated"
    },
    {
        seq_no:"17",
        question:"Quick Closing Valves"
    },
    {
        seq_no:"18",
        question:"Emergency lighting"
    },
    {
        seq_no:"19",
        question:"Medical locke"
    },
    {
        seq_no:"20",
        question:"Eyewash."
    },
    {
        seq_no:"21",
        question:"Gangway and condition of nets, ensure SWL and max persons are marked on both sides"
    },
    {
        seq_no:"22",
        question:"Fire detector"
    },
    {
        seq_no:"23",
        question:"Emergency steering"
    },
    {
        seq_no:"24",
        question:"Fenders and ropes"
    },
    {
        seq_no:"25",
        question:"Hatches, Vents and manholes and in good condition and are clearly marked"
    },
]